(() => {
  const initialize = (root) => {
    if (root.dataset.hsReady) return;
    root.dataset.hsReady = 'true';
    root.querySelectorAll('[data-hs-hub-help]').forEach((details) => {
      const summary = details.querySelector('summary');
      const openAutomatically = () => { if (!details.open) { details.open = true; details.dataset.hsAutoOpen = 'true'; } };
      const closeAutomatically = () => { if (details.dataset.hsAutoOpen && !details.matches(':focus-within')) { details.open = false; delete details.dataset.hsAutoOpen; } };
      details.addEventListener('pointerenter', (event) => { if (event.pointerType === 'mouse') openAutomatically(); });
      details.addEventListener('pointerleave', closeAutomatically);
      summary.addEventListener('focus', openAutomatically);
      summary.addEventListener('click', (event) => { if (details.dataset.hsAutoOpen) { event.preventDefault(); delete details.dataset.hsAutoOpen; details.open = true; } });
      details.addEventListener('focusout', (event) => { if (!details.contains(event.relatedTarget) && details.dataset.hsAutoOpen) { details.open = false; delete details.dataset.hsAutoOpen; } });
      details.addEventListener('keydown', (event) => { if (event.key === 'Escape') { event.preventDefault(); summary.focus(); details.open = false; delete details.dataset.hsAutoOpen; } });
      root.addEventListener('click', (event) => { if (!details.contains(event.target)) { details.open = false; delete details.dataset.hsAutoOpen; } });
    });
    const gallery = root.querySelector('[data-hs-gallery]');
    const showMedia = (id) => {
      if (!gallery || !id || !gallery.querySelector(`[data-hs-media="${CSS.escape(String(id))}"]`)) return;
      gallery.querySelectorAll('[data-hs-media]').forEach((panel) => {
        panel.hidden = panel.dataset.hsMedia !== String(id);
        if (panel.hidden) panel.querySelectorAll('video').forEach((video) => video.pause());
      });
      gallery.querySelectorAll('[data-hs-thumb]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.hsThumb === String(id))));
      const image = gallery.querySelector(`[data-hs-media="${CSS.escape(String(id))}"] > img`);
      const fullImage = gallery.querySelector('.hs-full-image');
      if (fullImage) fullImage.hidden = !image;
      if (image && fullImage) fullImage.href = image.closest('[data-hs-media]').dataset.hsFullImage || image.currentSrc || image.src;
      const activeThumb = gallery.querySelector('[data-hs-thumb][aria-pressed="true"]');
      const thumbs = gallery.querySelector('.hs-gallery-thumbs');
      if (activeThumb && thumbs) thumbs.scrollLeft = activeThumb.offsetLeft - thumbs.offsetLeft - (thumbs.clientWidth - activeThumb.offsetWidth) / 2;
      gallery.dispatchEvent(new Event('hs:mediachange'));
    };
    gallery?.querySelectorAll('[data-hs-thumb]').forEach((button) => button.addEventListener('click', () => showMedia(button.dataset.hsThumb)));
    const stage = gallery?.querySelector('.hs-gallery-stage');
    if (stage && gallery.querySelectorAll('[data-hs-media]').length > 1) {
      let gesture = null;
      stage.querySelectorAll('[data-hs-media] > img').forEach((image) => { image.draggable = false; });
      stage.addEventListener('pointerdown', (event) => {
        if (!event.isPrimary || gesture) { gesture = null; return; }
        if (!window.matchMedia('(max-width: 800px)').matches || event.button !== 0 || !event.target.matches('[data-hs-media] > img')) return;
        gesture = { id: event.pointerId, x: event.clientX, y: event.clientY };
        stage.setPointerCapture(event.pointerId);
      });
      stage.addEventListener('pointerup', (event) => {
        const start = gesture;
        gesture = null;
        if (!start || start.id !== event.pointerId) return;
        const dx = event.clientX - start.x;
        const dy = event.clientY - start.y;
        if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.4) return;
        const panels = [...gallery.querySelectorAll('[data-hs-media]')];
        const current = panels.findIndex((panel) => !panel.hidden);
        showMedia(panels[(current + (dx < 0 ? 1 : -1) + panels.length) % panels.length].dataset.hsMedia);
      });
      stage.addEventListener('pointercancel', () => { gesture = null; });
      stage.addEventListener('lostpointercapture', () => { gesture = null; });
    }
    if (gallery) {
      const toolbar = gallery.querySelector('[data-hs-gallery-tools]');
      const dialog = gallery.querySelector('[data-hs-zoom-dialog]');
      const zoom = gallery.querySelector('[data-hs-zoom]');
      const panels = [...gallery.querySelectorAll('[data-hs-media]')];
      const sync = () => {
        const current = panels.findIndex(panel => !panel.hidden);
        const image = panels[current]?.querySelector(':scope > img');
        gallery.querySelectorAll('[data-hs-gallery-count]').forEach(count => { count.textContent = `${current + 1} / ${panels.length}`; });
        if (zoom) zoom.disabled = !image;
        if (dialog?.open && image) { const target = dialog.querySelector('img'); target.removeAttribute('srcset'); target.removeAttribute('sizes'); target.src = gallery.querySelector('.hs-full-image').href; target.alt = image.alt; }
      };
      const move = delta => {
        const current = panels.findIndex(panel => !panel.hidden);
        let next = (current + delta + panels.length) % panels.length;
        if (dialog?.open) { for (let i=0;i<panels.length && !panels[next].querySelector(':scope > img');i++) next=(next+delta+panels.length)%panels.length; }
        showMedia(panels[next].dataset.hsMedia);
      };
      toolbar.hidden = false;
      gallery.querySelectorAll('[data-hs-gallery-prev]').forEach(button => button.addEventListener('click',()=>move(-1)));
      gallery.querySelectorAll('[data-hs-gallery-next]').forEach(button => button.addEventListener('click',()=>move(1)));
      zoom.addEventListener('click',()=>{ dialog.showModal(); sync(); });
      dialog.querySelector('[data-hs-zoom-close]').addEventListener('click',()=>dialog.close());
      dialog.addEventListener('click',event=>{ if(event.target===dialog){ const bounds=dialog.getBoundingClientRect(); if(event.clientX<bounds.left||event.clientX>bounds.right||event.clientY<bounds.top||event.clientY>bounds.bottom) dialog.close(); } });
      dialog.addEventListener('close',()=>zoom.focus({preventScroll:true}));
      dialog.addEventListener('keydown',event=>{ if(event.key==='ArrowLeft'||event.key==='ArrowRight'){ event.preventDefault(); move(event.key==='ArrowLeft'?-1:1); } });
      gallery.addEventListener('hs:mediachange',sync);
      sync();
    }
    root.querySelectorAll('[data-hs-video]').forEach((video) => {
      video.querySelectorAll('[data-hs-play]').forEach((button) => button.addEventListener('click', () => {
        const frame = video.querySelector('[data-hs-video-frame]');
        const id = video.dataset.videoId;
        if (!frame || !/^[a-zA-Z0-9_-]{11}$/.test(id || '')) return;
        const start = Math.max(0, Number.parseInt(button.dataset.start || '0', 10) || 0);
        let iframe = frame.querySelector('iframe');
        if (!iframe) {
          iframe = document.createElement('iframe');
          iframe.title = video.querySelector('[data-hs-play]')?.getAttribute('aria-label') || document.title;
          iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
          iframe.allowFullscreen = true;
          iframe.referrerPolicy = 'strict-origin-when-cross-origin';
          frame.replaceChildren(iframe);
        }
        iframe.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0&playsinline=1&start=${start}`;
        video.querySelectorAll('.hs-chapters button').forEach((chapter) => chapter.setAttribute('aria-pressed', String(chapter === button)));
      }));
    });
    const purchase = root.querySelector('[data-hs-purchase]');
    if (purchase) {
      let data;
      try { data = JSON.parse(purchase.querySelector('[data-hs-buy-data]').textContent); } catch { return; }
      const select = purchase.querySelector('[data-hs-variant]');
      const add = purchase.querySelector('[data-hs-add]');
      const quantity = purchase.querySelector('input[name="quantity"]');
      const updateVariant = (id, updateUrl) => {
        const variant = data.variants.find((entry) => entry.id === String(id));
        if (!variant) return;
        purchase.querySelector('[data-hs-price]').textContent = variant.price;
        const compare = purchase.querySelector('[data-hs-compare]');
        compare.textContent = variant.compare || '';
        compare.hidden = !variant.compare;
        add.disabled = !variant.available;
        add.textContent = variant.available ? data.messages.add : data.messages.sold;
        const status = purchase.querySelector('[data-hs-availability]');
        status.textContent = variant.available ? data.messages.available : data.messages.sold;
        status.classList.toggle('is-sold-out', !variant.available);
        purchase.querySelector('[data-hs-sku]').textContent = variant.sku || '';
        root.querySelectorAll('[data-hs-sticky-price]').forEach((price) => { price.textContent = variant.price; });
        showMedia(variant.media);
        if (updateUrl) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url);
        }
      };
      select?.addEventListener('change', () => updateVariant(select.value, true));
      purchase.querySelectorAll('[data-hs-quantity]').forEach((button) => button.addEventListener('click', () => {
        const current = Number.parseInt(quantity.value, 10);
        quantity.value = String(Math.max(1, (Number.isFinite(current) ? current : 1) + Number(button.dataset.hsQuantity)));
        quantity.dispatchEvent(new Event('change', {bubbles:true}));
      }));
      if (select) updateVariant(select.value, false);
    }
    const filters = root.querySelector('[data-hs-filters]');
    const tools = root.querySelector('[data-hs-discovery]');
    if (filters && tools) {
      filters.hidden = false;
      tools.hidden = false;
      const grid = root.querySelector('[data-hs-product-grid]');
      const cards = [...grid.querySelectorAll('[data-hs-card]')];
      const search = tools.querySelector('[data-hs-search]');
      const sort = tools.querySelector('[data-hs-sort]');
      const available = tools.querySelector('[data-hs-in-stock]');
      const count = tools.querySelector('[data-hs-count]');
      const empty = root.querySelector('[data-hs-empty]');
      const groups = [...filters.querySelectorAll('[data-hs-filter]')].map(button => button.dataset.hsFilter);
      let group = 'all';
      const normalize = value => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
      const update = (save = true) => {
        const words = normalize(search.value).split(/\s+/).filter(Boolean);
        let shown = 0;
        cards.forEach(card => {
          card.hidden = !(group === 'all' || card.dataset.group === group) || (available.checked && card.dataset.available !== 'true') || !words.every(word => normalize(card.dataset.search).includes(word));
          if (!card.hidden) shown++;
        });
        const ordered = [...cards];
        if (sort.value === 'price-asc') ordered.sort((a,b) => Number(a.dataset.price) - Number(b.dataset.price));
        if (sort.value === 'price-desc') ordered.sort((a,b) => Number(b.dataset.price) - Number(a.dataset.price));
        if (sort.value === 'title') ordered.sort((a,b) => a.dataset.title.localeCompare(b.dataset.title));
        ordered.forEach(card => grid.append(card));
        filters.querySelectorAll('[data-hs-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.hsFilter === group)));
        count.textContent = count.dataset.template.replace('[shown]', shown).replace('[total]', cards.length);
        empty.hidden = shown !== 0;
        if (save) {
          const url = new URL(location.href);
          [['halo_group',group === 'all' ? '' : group],['halo_q',search.value.trim()],['halo_sort',sort.value === 'featured' ? '' : sort.value],['halo_stock',available.checked ? '1' : '']].forEach(([key,value]) => value ? url.searchParams.set(key,value) : url.searchParams.delete(key));
          history.replaceState({},'',url);
        }
      };
      const readUrl = () => {
        const params = new URL(location.href).searchParams;
        group = groups.includes(params.get('halo_group')) ? params.get('halo_group') : 'all';
        search.value = (params.get('halo_q') || '').slice(0,100);
        sort.value = ['featured','price-asc','price-desc','title'].includes(params.get('halo_sort')) ? params.get('halo_sort') : 'featured';
        available.checked = params.get('halo_stock') === '1';
        update(false);
      };
      filters.querySelectorAll('[data-hs-filter]').forEach(button => button.addEventListener('click', () => { group = button.dataset.hsFilter; update(); }));
      search.addEventListener('input', () => update());
      sort.addEventListener('change', () => update());
      available.addEventListener('change', () => update());
      root.querySelectorAll('[data-hs-reset]').forEach(button => button.addEventListener('click', () => { group='all'; search.value=''; sort.value='featured'; available.checked=false; update(); search.focus({preventScroll:true}); }));
      window.addEventListener('popstate',readUrl);
      readUrl();
    }
    const nav = root.querySelector('.hs-subnav');
    if (nav && 'IntersectionObserver' in window) {
      const links = [...nav.querySelectorAll('a[href^="#"]')];
      const observer = new IntersectionObserver(entries => {
        const visible = entries.filter(entry => entry.isIntersecting).sort((a,b) => a.boundingClientRect.top - b.boundingClientRect.top);
        if (!visible.length) return;
        links.forEach(link => link.hash === '#' + visible[0].target.id ? link.setAttribute('aria-current','location') : link.removeAttribute('aria-current'));
      }, {rootMargin:'-10% 0px -55% 0px',threshold:0});
      links.forEach(link => { const target = root.querySelector(link.hash); if (target) observer.observe(target); });
      document.addEventListener('shopify:section:unload', event => { if(event.target.contains(root)) observer.disconnect(); }, {once:true});
    }
  };
  document.querySelectorAll('[data-hs-root]').forEach(initialize);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-hs-root]').forEach(initialize));
})();
